module.exports = __webpack_public_path__ + "static/media/leaf.eb4104c3.svg";